<!--
 * @Author: wsx
 * @Date: 2022-01-22 15:31:21
 * @LastEditTime: 2022-06-15 15:25:38
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description: 标题
-->
<template>
  <div class="HScroll">
    <div v-for="(item, index) in scrollList" :key="item.id" :id="item.id">
      <slot :name="item.slot"></slot>
    </div>
  </div>
</template>
<script >
export default {
  name: 'HScroll',
  props: {
    scrollList: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    return {};
  }
};
</script>
<style  lang='scss' scoped >
.HScroll {
}
</style>